import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { TextField, Button, CircularProgress, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import emailjs from 'emailjs-com'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: "6px 0",
    },
    '& label': {
      color: "#9d9b99",
      [theme.breakpoints.between(600,768)] : {
        fontSize: 12,
      },
    },
		'& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: "30px !important",
      },
      '&.MuiOutlinedInput-root fieldset': {
        background: "rgba(0,0,0,0.05)",
      },
    },
    "& .MuiOutlinedInput-input": {
      color: theme.palette.text.secondary,
      [theme.breakpoints.between(600,768)] : {
        fontSize: 12,
      },
    },
  },
  buttonWrapper: {
    position: "relative",
    display: "flex",
    margin: "auto",
  },
  sendButton: {
    borderRadius: "30px",
    "& .MuiButton-label": {
      margin: "0px 30px"
    }
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  snackbar: {
    zIndex: theme.zIndex.tooltip + 1,
  },
}));

export default function ContactForm(props) {
  const classes = useStyles()
  const form = useRef()
  const [status, setStatus] = useState('idle') // idle | sending | success | error
  const [feedbackOpen, setFeedbackOpen] = useState(false)

  const sendEmail = e => {
      e.preventDefault()
      setStatus('sending')

      emailjs.sendForm('service_cif34tw', 'template_g3517ma', form.current, 'LoQNwv6b5fVj8MSsf')
      .then((result) => {
          setStatus('success')
          setFeedbackOpen(true)
          form.current.reset()
      }, (error) => {
          console.log(error.text)
          setStatus('error')
          setFeedbackOpen(true)
      })
  }

  const handleCloseFeedback = (_event, reason) => {
      if (reason === 'clickaway') return
      setFeedbackOpen(false)
  }

  return (
    <>
    <form id="formulario-correo" ref={form} className={classes.root} noValidate autoComplete="off" onSubmit={sendEmail}>
            <TextField name="nombre" className="form-control" id="nombre" label="Nombre y Apellido" size="small" margin="none" fullWidth required variant="outlined" color="primary" style={{marginTop: 16}} disabled={status === 'sending'} />
            <TextField name="email" className="form-control" id="email" label="Email" size="small" margin="none" fullWidth required variant="outlined" color="primary" disabled={status === 'sending'} />
            <TextField name="asunto" className="form-control" id="asunto" size="small" margin="none" fullWidth variant="outlined" color="primary" value={props.asunto} disabled={status === 'sending'} />
            <TextField name="mensaje" className="form-control" id="mensaje" label="Mensaje" size="medium" margin="none" fullWidth required multiline minRows={4} variant="outlined" color="primary" disabled={status === 'sending'} />

            <div className={classes.buttonWrapper}>
              <Button className={classes.sendButton} variant="contained" size="large" color="primary" type="submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Enviando...' : 'Enviar'}
              </Button>
              {status === 'sending' && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
    </form>
    <Snackbar className={classes.snackbar} open={feedbackOpen} autoHideDuration={5000} onClose={handleCloseFeedback} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Alert onClose={handleCloseFeedback} severity={status === 'success' ? 'success' : 'error'} variant="filled">
        {status === 'success' ? 'El mensaje fue enviado con éxito' : 'Ocurrió un error al enviar el mensaje. Probá de nuevo.'}
      </Alert>
    </Snackbar>
    </>
  );
}